module.exports = __webpack_public_path__ + "img/WieGottInFrankreich.c2e9b855.svg";